import { useCallback, useEffect, useMemo, useState } from "react";
import type { ReactNode } from "react";

import { MessageSelectionContext, type MessageSelectionApi } from "./selection-context";

export function MessageSelectionProvider({
    chatId,
    children,
}: {
    // Смена чата сбрасывает выбор — сообщения другого чата к текущему не относятся.
    chatId: string | undefined;
    children: ReactNode;
}) {
    const [selected, setSelected] = useState<Set<string>>(() => new Set());

    useEffect(() => {
        setSelected(new Set());
    }, [chatId]);

    const toggle = useCallback((messageId: string) => {
        setSelected((prev) => {
            const next = new Set(prev);
            if (next.has(messageId)) next.delete(messageId);
            else next.add(messageId);
            return next;
        });
    }, []);

    const clear = useCallback(() => setSelected(new Set()), []);

    const api = useMemo<MessageSelectionApi>(
        () => ({
            selectedIds: [...selected],
            count: selected.size,
            isSelected: (messageId) => selected.has(messageId),
            toggle,
            clear,
        }),
        [selected, toggle, clear],
    );

    return <MessageSelectionContext.Provider value={api}>{children}</MessageSelectionContext.Provider>;
}
